import { Base } from './Base';
import { initBehaviors, destroyBehaviors } from '..';
import events from '../../constants/events';
import { dispatchEvent } from '../../utilities/customEvents'
import { getShopifyProductsByGlobalIds } from '../../utilities/getShopifyProductsByGlobalIds';
import compileProductCard from '../../utilities/compileProductCard';

import { relewiseRecommend } from '../../utilities/relewise';

export class PowerStep extends Base {
    constructor(behaviorName, element) {
        super(behaviorName, element)

        this.init();
    }

    init() {
        this.cacheLoadingMarkup();
        this.bindFunctions();
        this.setEventListeners();
    }

    bindFunctions() {
        this.handleItemAdded = this.handleItemAdded.bind(this);
    }

    setEventListeners() {
        window.addEventListener(events.ITEM_ADDED_WIDGET_OPENED, this.handleItemAdded);
        // window.addEventListener(events.ITEM_ADDED_WIDGET, this.handleItemAdded);
    }

    cacheLoadingMarkup() {
        const { carouselWrapper } = this.refs;
        this.loadingMarkup = carouselWrapper.innerHTML;
    }

    displayLoadingMarkup() {
        const { carouselWrapper } = this.refs;
        carouselWrapper.innerHTML = this.loadingMarkup;
    }

    handleItemAdded(e) {
        const { carousel } = this.refs;

        //Re-init when opened to calc sizes for placeholder markup
        destroyBehaviors(carousel);
        initBehaviors(carousel);

        const crossStoreProductId = e.detail.sku.substring(0, 6);
        const variantId = e.detail.sku;
        const vendor = e.detail.vendor;

        relewiseRecommend('PowerStep', {
            crossStoreProductId,
            variantId,
            vendor,

        })
        .then(response => response.json())
        .then(json => {
            if(json) {
                this.compileProductCards(
                    getShopifyProductsByGlobalIds(
                        this.applyDataModelling(json.recommendations)
                    )
                );
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    applyDataModelling(data) {
        const modeledData = [];

        data.forEach(entry => {
            modeledData.push({
                crossStoreProductId: parseInt(entry.productId),
                variantId: parseInt(entry.variant.variantId)
            })
        });

        return modeledData;
    }

    compileProductCards(products) {
        const { productCardTemplate, productCardMediaItemTemplate, carousel, carouselWrapper } = this.refs;

        const templates = {
            productCardTemplate,
            productCardMediaItemTemplate,
        }

        const settings = {
            hideTags: true,
            showPackshot: true,
            preselectURL: true,
        }

        carouselWrapper.innerHTML = '';

        for(const product of products) {
            carouselWrapper.innerHTML += `
            <div class="swiper-slide swiper-product-slide carousel__item carousel__item--4-of-8">
              ${compileProductCard(product, product.currentOrFirstVariant, templates, settings)}
            </div>
            `;
        }

        dispatchEvent(window, events.PRODUCT_IMAGES_UPDATED);

        //Destory before init, to re-init carousel
        requestAnimationFrame(() => {
          destroyBehaviors(carousel);
          initBehaviors(carousel);
        });
    }

    cleanup() {
        window.removeEventListener(events.ITEM_ADDED_WIDGET_OPENED, this.handleItemAdded);
    }
}
